export type { ToastTitleProps, ToastTitleSlots, ToastTitleState } from './components/ToastTitle/index';
export {
  ToastTitle,
  renderToastTitle_unstable,
  toastTitleClassNames,
  useToastTitleStyles_unstable,
  useToastTitle_unstable,
} from './components/ToastTitle/index';
